// Realistic demo data for a pizza shop

export const DEMO_INGREDIENTS = [
  { name: 'Pizza Dough Flour (00)', vendor: 'Sysco', category: 'Dry Goods', purchaseCost: 32.00, purchaseQuantity: 50, purchaseUnit: 'lb', yieldPercent: 98, notes: 'Caputo-style 00 flour' },
  { name: 'Whole Milk Mozzarella', vendor: 'US Foods', category: 'Dairy', purchaseCost: 48.50, purchaseQuantity: 10, purchaseUnit: 'lb', yieldPercent: 95, notes: 'Low-moisture, shredded' },
  { name: 'San Marzano Tomatoes (Crushed)', vendor: 'Sysco', category: 'Sauces', purchaseCost: 5.80, purchaseQuantity: 106, purchaseUnit: 'oz', yieldPercent: 100, notes: '#10 can' },
  { name: 'Pepperoni (Sliced)', vendor: 'US Foods', category: 'Meat', purchaseCost: 42.00, purchaseQuantity: 10, purchaseUnit: 'lb', yieldPercent: 100, notes: 'Cup & char style' },
  { name: 'Italian Sausage (Raw)', vendor: 'Local Farm', category: 'Meat', purchaseCost: 6.50, purchaseQuantity: 1, purchaseUnit: 'lb', yieldPercent: 85, notes: 'Sweet fennel blend' },
  { name: 'Fresh Basil', vendor: 'Produce Co', category: 'Produce', purchaseCost: 3.00, purchaseQuantity: 2, purchaseUnit: 'oz', yieldPercent: 80, notes: 'Organic bunch' },
  { name: 'Olive Oil (Extra Virgin)', vendor: 'Sysco', category: 'Sauces', purchaseCost: 28.00, purchaseQuantity: 1, purchaseUnit: 'gallon', yieldPercent: 100, notes: 'Finishing and dough' },
  { name: 'Pizza Box (14")', vendor: 'Restaurant Depot', category: 'Packaging', purchaseCost: 42.00, purchaseQuantity: 50, purchaseUnit: 'each', yieldPercent: 100, notes: 'Corrugated, branded' },
  { name: 'Parmesan (Grated)', vendor: 'US Foods', category: 'Dairy', purchaseCost: 18.00, purchaseQuantity: 2, purchaseUnit: 'lb', yieldPercent: 100, notes: 'Domestic Parm' },
  { name: 'Garlic (Minced)', vendor: 'Sysco', category: 'Produce', purchaseCost: 8.50, purchaseQuantity: 32, purchaseUnit: 'oz', yieldPercent: 100, notes: 'Jarred, pre-minced' },
  { name: 'Red Onion', vendor: 'Produce Co', category: 'Produce', purchaseCost: 1.80, purchaseQuantity: 1, purchaseUnit: 'lb', yieldPercent: 88, notes: 'Sliced thin' },
  { name: 'Green Bell Pepper', vendor: 'Produce Co', category: 'Produce', purchaseCost: 1.20, purchaseQuantity: 1, purchaseUnit: 'lb', yieldPercent: 82, notes: 'Diced for topping' },
];

// Helper — these get real IDs when loaded via addIngredient
// The recipe references ingredients by index, resolved at load time
export const DEMO_RECIPES = [
  {
    name: 'Large Cheese Pizza',
    category: 'Pizza',
    menuPrice: 16.99,
    targetFoodCostPercent: 28,
    targetPrimeCostPercent: 55,
    packagingCost: 0.84,
    prepMinutes: 5,
    cookMinutes: 12,
    laborWage: 16,
    laborBurdenPercent: 25,
    notes: '14" classic cheese, our #1 seller',
    ingredientRefs: [
      { ingredientIndex: 0, amount: 18, unit: 'oz' },   // dough flour
      { ingredientIndex: 1, amount: 8, unit: 'oz' },    // mozzarella
      { ingredientIndex: 2, amount: 6, unit: 'oz' },    // tomato sauce
      { ingredientIndex: 5, amount: 0.25, unit: 'oz' }, // basil
      { ingredientIndex: 6, amount: 0.5, unit: 'oz' },  // olive oil
    ],
  },
  {
    name: 'Large Pepperoni Pizza',
    category: 'Pizza',
    menuPrice: 19.99,
    targetFoodCostPercent: 28,
    targetPrimeCostPercent: 55,
    packagingCost: 0.84,
    prepMinutes: 6,
    cookMinutes: 12,
    laborWage: 16,
    laborBurdenPercent: 25,
    notes: '14" pepperoni, crowd favorite',
    ingredientRefs: [
      { ingredientIndex: 0, amount: 18, unit: 'oz' },   // dough flour
      { ingredientIndex: 1, amount: 8, unit: 'oz' },    // mozzarella
      { ingredientIndex: 2, amount: 6, unit: 'oz' },    // tomato sauce
      { ingredientIndex: 3, amount: 3, unit: 'oz' },    // pepperoni
      { ingredientIndex: 6, amount: 0.5, unit: 'oz' },  // olive oil
    ],
  },
  {
    name: 'Sausage & Pepper Pizza',
    category: 'Pizza',
    menuPrice: 21.99,
    targetFoodCostPercent: 30,
    targetPrimeCostPercent: 55,
    packagingCost: 0.84,
    prepMinutes: 8,
    cookMinutes: 14,
    laborWage: 16,
    laborBurdenPercent: 25,
    notes: 'Specialty pie — sausage, pepper, onion',
    ingredientRefs: [
      { ingredientIndex: 0, amount: 18, unit: 'oz' },   // dough flour
      { ingredientIndex: 1, amount: 10, unit: 'oz' },   // mozzarella
      { ingredientIndex: 2, amount: 6, unit: 'oz' },    // tomato sauce
      { ingredientIndex: 4, amount: 4, unit: 'oz' },    // sausage
      { ingredientIndex: 10, amount: 2, unit: 'oz' },   // red onion
      { ingredientIndex: 11, amount: 2, unit: 'oz' },   // green pepper
      { ingredientIndex: 6, amount: 0.5, unit: 'oz' },  // olive oil
    ],
  },
];

export const DEMO_BREAK_EVEN = {
  rent: 4500,
  utilities: 800,
  insurance: 350,
  software: 250,
  payroll: 8500,
  managerSalary: 4200,
  loanPayments: 600,
  otherFixed: 300,
  avgOrderValue: 28,
  avgContributionMargin: 62,
};

export const DEMO_PNL = {
  revenue: 52000,
  cogs: 15600,
  labor: 14560,
  rent: 4500,
  utilities: 800,
  marketing: 1200,
  software: 250,
  insurance: 350,
};
